/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StockManageListSkuItem } from './StockManageListSkuItem';
import {
    StockManageListSkuItemFromJSON,
    StockManageListSkuItemFromJSONTyped,
    StockManageListSkuItemToJSON,
    StockManageListSkuItemToJSONTyped,
} from './StockManageListSkuItem';

/**
 * 
 * @export
 * @interface StockManageListResVo
 */
export interface StockManageListResVo {
    /**
     * SPU主键ID
     * @type {number}
     * @memberof StockManageListResVo
     */
    spuId?: number;
    /**
     * 登录商品编号（SPU编码）
     * @type {string}
     * @memberof StockManageListResVo
     */
    spuCode?: string;
    /**
     * 商品图片URL
     * @type {string}
     * @memberof StockManageListResVo
     */
    imageUrl?: string;
    /**
     * 商品名称
     * @type {string}
     * @memberof StockManageListResVo
     */
    productName?: string;
    /**
     * 商品总数（当前仓库库存合计）
     * @type {number}
     * @memberof StockManageListResVo
     */
    totalItemQty?: number;
    /**
     * 已出库数量（当前仓库合计）
     * @type {number}
     * @memberof StockManageListResVo
     */
    outboundQty?: number;
    /**
     * 有效期限标识：Y-有，N-无
     * @type {string}
     * @memberof StockManageListResVo
     */
    validPeriod?: string;
    /**
     * 注册日期
     * @type {string}
     * @memberof StockManageListResVo
     */
    registerDate?: string;
    /**
     * 
     * @type {Array<StockManageListSkuItem>}
     * @memberof StockManageListResVo
     */
    skus?: Array<StockManageListSkuItem>;
}

/**
 * Check if a given object implements the StockManageListResVo interface.
 */
export function instanceOfStockManageListResVo(value: object): value is StockManageListResVo {
    return true;
}

export function StockManageListResVoFromJSON(json: any): StockManageListResVo {
    return StockManageListResVoFromJSONTyped(json, false);
}

export function StockManageListResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): StockManageListResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'spuId': json['spuId'] == null ? undefined : json['spuId'],
        'spuCode': json['spuCode'] == null ? undefined : json['spuCode'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'productName': json['productName'] == null ? undefined : json['productName'],
        'totalItemQty': json['totalItemQty'] == null ? undefined : json['totalItemQty'],
        'outboundQty': json['outboundQty'] == null ? undefined : json['outboundQty'],
        'validPeriod': json['validPeriod'] == null ? undefined : json['validPeriod'],
        'registerDate': json['registerDate'] == null ? undefined : json['registerDate'],
        'skus': json['skus'] == null ? undefined : ((json['skus'] as Array<any>).map(StockManageListSkuItemFromJSON)),
    };
}

export function StockManageListResVoToJSON(json: any): StockManageListResVo {
    return StockManageListResVoToJSONTyped(json, false);
}

export function StockManageListResVoToJSONTyped(value?: StockManageListResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'spuId': value['spuId'],
        'spuCode': value['spuCode'],
        'imageUrl': value['imageUrl'],
        'productName': value['productName'],
        'totalItemQty': value['totalItemQty'],
        'outboundQty': value['outboundQty'],
        'validPeriod': value['validPeriod'],
        'registerDate': value['registerDate'],
        'skus': value['skus'] == null ? undefined : ((value['skus'] as Array<any>).map(StockManageListSkuItemToJSON)),
    };
}

